import { render } from "./App.vue?vue&type=template&id=32352caa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=32352caa&lang=scss&scoped=true"

import exportComponent from "/Users/home/Documents/GitHub/pixelswish vue 3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32352caa"]])

export default __exports__